export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function convertSnakeCaseToTitleCase(str: string) {
  if (!str) return "";
  return str
    .toLocaleLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function getInitials(name: string) {
  // This case should never happen ideally
  if (!name) return "AA";
  const intials = name.split(" ").map((n) => n[0]?.toUpperCase());
  if (intials.length === 1) {
    return intials[0];
  }
  return [intials[0], intials[intials.length - 1]].join("");
}

export function titleCase(str: string) {
  if (!str) return str;
  return str
    .split(" ")
    .map((c) => capitalize(c))
    .join(" ");
}

export function addFullStopToSentence(str: string) {
  if (!str) return str;
  return str.trim().endsWith(".") ? str.trim() : `${str.trim()}.`;
}

export function getFirstName(name?: string) {
  if (!name) return "";
  return name.trim().split(" ").at(0);
}

export function maskEmail(email: string) {
  if (!email) return email;
  const [username, domain] = email.split("@");

  if (!username || !domain) return email;

  if (username.length <= 2) {
    return `${username[0]}*@${domain}`;
  }

  const masked =
    username[0] +
    "*".repeat(username.length - 2) +
    username[username.length - 1];

  return `${masked}@${domain}`;
}

export function withOrdinalSuffix(i: number) {
  const j = i % 10;
  const k = i % 100;
  if (j === 1 && k !== 11) {
    return `${i}st`;
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && k !== 13) {
    return `${i}rd`;
  }
  return `${i}th`;
}
